import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import { useDataSlider } from "../../main-cover-hook";
import styles from "./main-cover-4.module.css";
import { LazyVideo } from "../../../../";
import { UiButton } from "@ui-monorepo/index";
import WidgetContainer from "../../../widget-container";
import { ContentCoverContext } from "../../main-cover.context";
import ArrowsSliderCover from "../components/arrows-slider-covers/arrows-slider-covers";


const MainCover4 = () => {
  const { theme, isMobile, storeMetadata, stepToPause } = useContext(ContentCoverContext);
  const { handleClickScroll, items } = useDataSlider();
  const sliderRef = useRef<Slider>(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: items.length > 1,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    speed: 400,
    prevArrow: <ArrowsSliderCover userTheme={theme} />,
    nextArrow: <ArrowsSliderCover userTheme={theme} />,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }],

    beforeChange: (current: number, next: number) => setActiveSlide(next)
  };

  const videoIsActive = useMemo(() => {
    return !!items[activeSlide]?.video;
  }, [activeSlide, items]);

  useEffect(() => {
    if (!!stepToPause || stepToPause === 0) {
      sliderRef?.current?.slickGoTo(stepToPause);
      sliderRef?.current?.slickPause();
    } else {
      sliderRef?.current?.slickPlay();
    }
  }, [stepToPause]);

  useEffect(() => {
    if (videoIsActive) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
  }, [videoIsActive]);

  return (
    <WidgetContainer className={styles.widgetContainer} withoutPadding>
      <div className={`${styles.mainCover4} ${styles.mainCover4Container}`}>
        <Slider ref={sliderRef} {...settings}>
          {items.map((item, index) =>
          <div key={`cover2-item-${index}`}>
              <div className={`${styles.sliderCard}`}>
                <div
                className={` ${styles.sliderImg}  ${
                item?.video ? `${styles.sliderZnone}` : `${styles.sliderZ}`
                }`}>

                  {item?.video &&
                <LazyVideo
                  storeMetadata={storeMetadata}
                  videoUrl={item.video}
                  play={videoIsActive}
                  className={"slider-cover-4"}
                  borderRadius={"10px"}
                  theme={theme} />}


                  {item?.imageDesktop && !isMobile &&
                <img
                  src={item?.imageDesktop}
                  className={styles.portraitImg}
                  alt={"slider-img"}
                  loading='eager' />}


                  {item?.imageMobile && isMobile &&
                <img
                  src={item?.imageMobile}
                  className={styles.portraitImg}
                  alt={"slider-img"}
                  loading='eager' />}


                </div>
                {!item.video && (
              item.config?.enabled || item.config?.enabled_button) &&
              <div className={styles.sliderBox}>
                      <div
                  className={`${
                  styles[item.config?.position || "center"]
                  } ${styles.sliderBoxTitle}`}>

                        {item.config?.enabled && item.title &&
                  <div className={styles.sliderBoxTitleText}>
                            {item.title &&
                    <h1 className={styles.sliderSellerName}>
                                {item?.title}
                              </h1>}

                          </div>}

                        {item.config?.enabled_button && item.link ?
                  <UiButton
                    hasPersonalization
                    isFilled
                    onClick={() =>
                    handleClickScroll(
                      item.link?.value,
                      item.link?.elementId
                    )}

                    theme={theme}>

                            <div className={styles.sliderSellerBtnText}>
                              {item.link.label}
                            </div>
                          </UiButton> :
                  null}
                      </div>
                    </div>}

              </div>
            </div>
          )}
        </Slider>
      </div>
    </WidgetContainer>);

};

export default MainCover4;